import { Breadcrumbs, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import {
  keywordResearchSubmenuTitles,
  paths
} from 'src/common/config/TextMessage';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useKeywordAssist } from '../Providers/KAProviders';
import { keywordResearchDashBoardCss } from 'src/content/keywordResearch/keywordResearchCSS';

interface BreadcrumbConfig {
  text: string;
  path?: string | (() => void);
  isActive?: boolean;
}

const KeywordAssistBreadcrumbs = () => {

  const { state: { currentView, detailedViewURL }, changeCurrentView } = useKeywordAssist();

  const navigate = useNavigate();

  const getBreadcrumbs = (currentView: string): BreadcrumbConfig[] => {
    switch (currentView) {
      case 'overview':
        return [
          {
            text: 'Orbit AI',
            path: paths.orbitAiAgent
          },
          {
            text: keywordResearchSubmenuTitles.keywordAssist,
            path: paths.keywordAssist
          }
        ];

      case 'detailed':
        return [
          {
            text: 'Orbit AI',
            path: paths.orbitAiAgent
          },
          {
            text: keywordResearchSubmenuTitles.keywordAssist,
            path: () => changeCurrentView('overview')
          },
          {
            text: detailedViewURL,
            isActive: true
          }
        ];
    }
  };

  const breadcrumbs = useMemo(() => getBreadcrumbs(currentView), [currentView, detailedViewURL]);

  const breadcrumbElements = breadcrumbs.map((crumb, index) => {
    const isLast = index === breadcrumbs.length - 1;
    const isActive = crumb.isActive !== undefined ? crumb.isActive : isLast;

    const handleClick = () => {
      if (crumb.path) {
        if (typeof crumb.path === 'function') {
          crumb.path();
        } else {
          navigate(crumb.path);
        }
      }
    };

    return (
      <Typography
        key={index}
        sx={{
          ...(isActive
            ? keywordResearchDashBoardCss?.breadCrumbText
            : keywordResearchDashBoardCss?.breadCrumbLightText),
          ...(!isActive && { cursor: 'pointer' })
        }}
        onClick={!isActive ? handleClick : undefined}
      >
        {crumb.text}
      </Typography>
    );
  });

  return (
    <Breadcrumbs
      separator={
        <NavigateNextIcon
          fontSize="small"
          sx={keywordResearchDashBoardCss?.navigateNextIcon}
        />
      }
      aria-label="breadcrumb"
    >
      {breadcrumbElements}
    </Breadcrumbs>
  );
};

export default KeywordAssistBreadcrumbs;
